import { textAreaValidator } from "~/core/validators/validators";

export function getTextAreaLogic() {
  const text = ref("");
  const textAreaField = ref<any>(null);
  function resetTextAreaValidation() {
    textAreaField.value.resetValidation();
  }
  const maxTextCharacters = 300;
  const currentTextCharacters = computed(() => {
    return text.value.length;
  });

  return {
    text,
    textAreaField,
    resetTextAreaValidation,
    textAreaValidator,
    maxTextCharacters,
    currentTextCharacters,
  };
}
